"use client";
import { useModalBaseContext } from "./ModalBase.context.mjs";
import { useEffect } from "react";
//#region packages/@mantine/core/src/components/ModalBase/use-modal-title-id.ts
function useModalTitle() {
	const ctx = useModalBaseContext();
	useEffect(() => {
		ctx.setTitleMounted(true);
		return () => ctx.setTitleMounted(false);
	}, []);
	return ctx.getTitleId();
}
//#endregion
export { useModalTitle };

//# sourceMappingURL=use-modal-title-id.mjs.map